import { JobCampaignFormData } from "../components/Compaign/Forms/Form6";

export const currencies = ["USD", "EUR", "GBP", "INR", "JPY", "AUD"];

export const periods = ["Hourly", "Weekly", "Monthly", "Yearly"];

export const periodOptions = [
  { label: "Yearly", value: "yearly" },
  { label: "Monthly", value: "monthly" },
  { label: "Hourly", value: "hourly" },
];


export const employmentTypes = [
  "Full-Time",
  "Part-Time",
  "Contract",
  "Internship",
];

export const educationLevels = ["High School", "Bachelor's", "Master's", "PhD"];

export const filterBy = ["All Types", "Bundle Only", "Free Add-on Only"];

// Sort options when other filters are selected
export const sortByOthers = ["Relevant", "High Price", "Low Price"];

export const countryCodes = ["+44", "+1", "+49"];

export const getInitialExperienceState = () => ({
  id: Date.now().toString(),
  title: "",
  company: "",
  location: "",
  description: "",
  currentlyWorking: false,
  startDate: "",
  endDate: "",
  years: "",
  role: "",
});

// Sort options when "All Types" is selected
export const sortByAllTypes = [
  "Recommended First",
  "Relevant",
  "High Price",
  "Low Price",
];

export function updateCampaignFormData(
  formData: JobCampaignFormData,
  fieldName: string,
  newValue: any
): JobCampaignFormData {
  const newFormData: JobCampaignFormData = { ...formData };

  switch (fieldName) {
    case "selectedEducation":
      newFormData.Form3Data = newFormData.Form3Data || {};
      newFormData.Form3Data.education = newValue;
      break;
    case "selectedSeniority":
      newFormData.Form3Data = newFormData.Form3Data || {};
      newFormData.Form3Data.seniority = newValue;
      break;
    case "selectedJobFunction":
      newFormData.Form3Data = newFormData.Form3Data || {};
      newFormData.Form3Data.jobFunction = newValue;
      break;
    case "selectedIndustry":
      newFormData.Form3Data = newFormData.Form3Data || {};
      newFormData.Form3Data.industry = newValue;
      break;

    case "recruiterFullName":
      newFormData.Form4Data = newFormData.Form4Data || {};
      newFormData.Form4Data.recruiterFullName = newValue;
      break;
    case "recruiterEmail":
      newFormData.Form4Data = newFormData.Form4Data || {};
      newFormData.Form4Data.recruiterEmail = newValue;
      break;
    case "contactFullName":
      newFormData.Form4Data = newFormData.Form4Data || {};
      newFormData.Form4Data.contactFullName = newValue;
      break;
    case "contactEmail":
      newFormData.Form4Data = newFormData.Form4Data || {};
      newFormData.Form4Data.contactEmail = newValue;
      break;
    case "contactPhone":
      newFormData.Form4Data = newFormData.Form4Data || {};
      newFormData.Form4Data.contactPhone = newValue;
      break;

    case "campaignName":
      newFormData.Form5Data = newFormData.Form5Data || {
        campaignData: {},
        workingLocation: {},
      };
      newFormData.Form5Data.campaignData =
        newFormData.Form5Data.campaignData || {};
      newFormData.Form5Data.campaignData.campaignName = newValue;
      break;
    case "jobTitle":
      newFormData.Form5Data = newFormData.Form5Data || {
        campaignData: {},
        workingLocation: {},
      };
      newFormData.Form5Data.campaignData =
        newFormData.Form5Data.campaignData || {};
      newFormData.Form5Data.campaignData.jobTitle = newValue;
      break;
    case "jobDescription":
      newFormData.Form5Data = newFormData.Form5Data || {
        campaignData: {},
        workingLocation: {},
      };
      newFormData.Form5Data.campaignData =
        newFormData.Form5Data.campaignData || {};
      newFormData.Form5Data.campaignData.jobDescription = newValue;
      break;
    case "yearsOfExperience":
      newFormData.Form5Data = newFormData.Form5Data || {
        campaignData: {},
        workingLocation: {},
      };
      newFormData.Form5Data.campaignData =
        newFormData.Form5Data.campaignData || {};
      newFormData.Form5Data.campaignData.yearsOfExperience = newValue;
      break;
    case "employmentType":
      newFormData.Form5Data = newFormData.Form5Data || {
        campaignData: {},
        workingLocation: {},
      };
      newFormData.Form5Data.campaignData =
        newFormData.Form5Data.campaignData || {};
      newFormData.Form5Data.campaignData.employmentType = newValue;
      break;

    case "fromWorkingHours":
      newFormData.Form5Data = newFormData.Form5Data || {
        campaignData: {},
        workingLocation: {},
      };
      newFormData.Form5Data.campaignData =
        newFormData.Form5Data.campaignData || {};
      newFormData.Form5Data.campaignData.fromWorkingHours = newValue;
      break;
    case "fromWorkingMinutes":
      newFormData.Form5Data = newFormData.Form5Data || {
        campaignData: {},
        workingLocation: {},
      };
      newFormData.Form5Data.campaignData =
        newFormData.Form5Data.campaignData || {};
      newFormData.Form5Data.campaignData.fromWorkingMinutes = newValue;
      break;
    case "toWorkingHours":
      newFormData.Form5Data = newFormData.Form5Data || {
        campaignData: {},
        workingLocation: {},
      };
      newFormData.Form5Data.campaignData =
        newFormData.Form5Data.campaignData || {};
      newFormData.Form5Data.campaignData.toWorkingHours = newValue;
      break;
    case "toWorkingMinutes":
      newFormData.Form5Data = newFormData.Form5Data || {
        campaignData: {},
        workingLocation: {},
      };
      newFormData.Form5Data.campaignData =
        newFormData.Form5Data.campaignData || {};
      newFormData.Form5Data.campaignData.toWorkingMinutes = newValue;
      break;

    case "salaryIndicationFrom":
      newFormData.Form5Data = newFormData.Form5Data || {
        campaignData: {},
        workingLocation: {},
      };
      newFormData.Form5Data.campaignData =
        newFormData.Form5Data.campaignData || {};
      newFormData.Form5Data.campaignData.salaryIndicationFrom = newValue;
      break;
    case "salaryIndicationTo":
      newFormData.Form5Data = newFormData.Form5Data || {
        campaignData: {},
        workingLocation: {},
      };
      newFormData.Form5Data.campaignData =
        newFormData.Form5Data.campaignData || {};
      newFormData.Form5Data.campaignData.salaryIndicationTo = newValue;
      break;
    case "currency":
      newFormData.Form5Data = newFormData.Form5Data || {
        campaignData: {},
        workingLocation: {},
      };
      newFormData.Form5Data.campaignData =
        newFormData.Form5Data.campaignData || {};
      newFormData.Form5Data.campaignData.currency = newValue;
      break;
    case "period":
      newFormData.Form5Data = newFormData.Form5Data || {
        campaignData: {},
        workingLocation: {},
      };
      newFormData.Form5Data.campaignData =
        newFormData.Form5Data.campaignData || {};
      newFormData.Form5Data.campaignData.period = newValue;
      break;

    case "addressLine1":
      newFormData.Form5Data = newFormData.Form5Data || {
        campaignData: {},
        workingLocation: {},
      };
      newFormData.Form5Data.workingLocation =
        newFormData.Form5Data.workingLocation || {};
      newFormData.Form5Data.workingLocation.addressLine1 = newValue;
      break;
    case "addressLine2":
      newFormData.Form5Data = newFormData.Form5Data || {
        campaignData: {},
        workingLocation: {},
      };
      newFormData.Form5Data.workingLocation =
        newFormData.Form5Data.workingLocation || {};
      newFormData.Form5Data.workingLocation.addressLine2 = newValue;
      break;
    case "postCode":
      newFormData.Form5Data = newFormData.Form5Data || {
        campaignData: {},
        workingLocation: {},
      };
      newFormData.Form5Data.workingLocation =
        newFormData.Form5Data.workingLocation || {};
      newFormData.Form5Data.workingLocation.postCode = newValue;
      break;
    case "city":
      newFormData.Form5Data = newFormData.Form5Data || {
        campaignData: {},
        workingLocation: {},
      };
      newFormData.Form5Data.workingLocation =
        newFormData.Form5Data.workingLocation || {};
      newFormData.Form5Data.workingLocation.city = newValue;
      break;
    case "country":
      newFormData.Form5Data = newFormData.Form5Data || {
        campaignData: {},
        workingLocation: {},
      };
      newFormData.Form5Data.workingLocation =
        newFormData.Form5Data.workingLocation || {};
      newFormData.Form5Data.workingLocation.country = newValue;
      break;
    case "allowsRemoteWork":
      newFormData.Form5Data = newFormData.Form5Data || {
        campaignData: {},
        workingLocation: {},
      };
      newFormData.Form5Data.workingLocation =
        newFormData.Form5Data.workingLocation || {};
      newFormData.Form5Data.workingLocation.allowsRemoteWork = newValue;
      break;

    default:
      break;
  }

  return newFormData;
}

export const filterByOptions = [
  { value: "All Types", label: "All Types" },
  { value: "Bundle Only", label: "Bundle Only" },
  { value: "Free Add-on Only", label: "Free Add-on Only" },
];

export const keyValueForCurrency = {
  "albanian lek": "ALL",
  "algerian dinar": "DZD",
  "angolan kwanza": "AOA",
  "argentine peso": "ARS",
  "armenian dram": "AMD",
  "aruban florin": "AWG",
  "australian dollar": "AUD",
  "azerbaijani manat": "AZN",
  "bahamian dollar": "BSD",
  "bahraini dinar": "BHD",
  "bangladeshi taka": "BDT",
  "barbadian dollar": "BBD",
  "belize dollar": "BZD",
  "bermudian dollar": "BMD",
  "bhutanese ngultrum": "BTN",
  "bolivian boliviano": "BOB",
  "bosnia-herzegovina convertible mark": "BAM",
  "botswana pula": "BWP",
  "brazilian real": "BRL",
  "british pound sterling": "GBP",
  "brunei dollar": "BND",
  "bulgarian lev": "BGN",
  "burundian franc": "BIF",
  "cambodian riel": "KHR",
  "canadian dollar": "CAD",
  "cape verdean escudo": "CVE",
  "cayman islands dollar": "KYD",
  "west african cfa franc": "XOF",
  "central african cfa franc": "XAF",
  "cfp franc": "XPF",
  "chilean peso": "CLP",
  "chinese yuan": "CNY",
  "colombian peso": "COP",
  "comorian franc": "KMF",
  "congolese franc": "CDF",
  "costa rican colón": "CRC",
  "croatian kuna": "HRK",
  "czech koruna": "CZK",
  "danish krone": "DKK",
  "djiboutian franc": "DJF",
  "dominican peso": "DOP",
  "east caribbean dollar": "XCD",
  "egyptian pound": "EGP",
  "eritrean nakfa": "ERN",
  "ethiopian birr": "ETB",
  euro: "EUR",
  "falkland islands pound": "FKP",
  "fijian dollar": "FJD",
  "gambian dalasi": "GMD",
  "georgian lari": "GEL",
  "ghanaian cedi": "GHS",
  "gibraltar pound": "GIP",
  "guatemalan quetzal": "GTQ",
  "guinean franc": "GNF",
  "guyanese dollar": "GYD",
  "haitian gourde": "HTG",
  "honduran lempira": "HNL",
  "hong kong dollar": "HKD",
  "hungarian forint": "HUF",
  "icelandic króna": "ISK",
  "indian rupee": "INR",
  "indonesian rupiah": "IDR",
  "iranian rial": "IRR",
  "iraqi dinar": "IQD",
  "israeli new shekel": "ILS",
  "jamaican dollar": "JMD",
  "japanese yen": "JPY",
  "jordanian dinar": "JOD",
  "kazakhstani tenge": "KZT",
  "kenyan shilling": "KES",
  "kuwaiti dinar": "KWD",
  "kyrgyzstani som": "KGS",
  "lao kip": "LAK",
  "lebanese pound": "LBP",
  "liberian dollar": "LRD",
  "libyan dinar": "LYD",
  "macanese pataca": "MOP",
  "macedonian denar": "MKD",
  "malagasy ariary": "MGA",
  "malawian kwacha": "MWK",
  "malaysian ringgit": "MYR",
  "mauritian rupee": "MUR",
  "mexican peso": "MXN",
  "moldovan leu": "MDL",
  "moroccan dirham": "MAD",
  "myanmar kyat": "MMK",
  "namibian dollar": "NAD",
  "nepalese rupee": "NPR",
  "netherlands antillean guilder": "ANG",
  "new zealand dollar": "NZD",
  "nicaraguan córdoba": "NIO",
  "nigerian naira": "NGN",
  "north korean won": "KPW",
  "norwegian krone": "NOK",
  "omani rial": "OMR",
  "pakistani rupee": "PKR",
  "panamanian balboa": "PAB",
  "papua new guinean kina": "PGK",
  "paraguayan guaraní": "PYG",
  "peruvian sol": "PEN",
  "philippine peso": "PHP",
  "polish złoty": "PLN",
  "qatari riyal": "QAR",
  "romanian leu": "RON",
  "rwandan franc": "RWF",
  "salvadoran colón": "SVC",
  "samoan tālā": "WST",
  "saudi riyal": "SAR",
  "serbian dinar": "RSD",
  "seychellois rupee": "SCR",
  "sierra leonean leone": "SLL",
  "singapore dollar": "SGD",
  "solomon islands dollar": "SBD",
  "somali shilling": "SOS",
  "south african rand": "ZAR",
  "south korean won": "KRW",
  "sri lankan rupee": "LKR",
  "saint helena pound": "SHP",
  "sudanese pound": "SDG",
  "surinamese dollar": "SRD",
  "swazi lilangeni": "SZL",
  "swedish krona": "SEK",
  "swiss franc": "CHF",
  "syrian pound": "SYP",
  "tajikistani somoni": "TJS",
  "tanzanian shilling": "TZS",
  "thai baht": "THB",
  "tongan paʻanga": "TOP",
  "trinidad and tobago dollar": "TTD",
  "tunisian dinar": "TND",
  "turkish lira": "TRY",
  "ugandan shilling": "UGX",
  "ukrainian hryvnia": "UAH",
  "united arab emirates dirham": "AED",
  "uruguayan peso": "UYU",
  "us dollar": "USD",
  "uzbekistani som": "UZS",
  "vanuatu vatu": "VUV",
  "vietnamese đồng": "VND",
  "yemeni rial": "YER",
} as const;

// Backend-safe employment type options with labels mapped to API enum values
export const employmentTypeOptions = [
  { label: "Permanent", value: "permanent" },
  { label: "Temporary", value: "temporary" },
  { label: "Fixed Term", value: "fixed_term" },
  {
    label: "Fixed Term With Option For Permanent",
    value: "fixed_term_with_option_for_permanent",
  },
  { label: "Freelance", value: "freelance" },
  { label: "Traineeship", value: "traineeship" },
  { label: "Internship", value: "internship" },
  { label: "Others", value: "others" },
] as const;
